<template>
  <div>
    <div class="popup-container py-10 px-8 shadow fixed sm:px-12">
      <button
        class="close-btn absolute"
        @click="$emit('close')"
      >
        <img
          class="w-3 h-3 mx-auto"
          src="@/assets/icons/btn-close.png"
        >
      </button>
      <slot />
    </div>
    <div
      class="modal-backdrop fixed opacity-50 bg-black inset-0"
      @click="clickBackdrop()"
    />
  </div>
</template>

<script>
export default {
  props: {
    allowBackdropClose: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    clickBackdrop () {
      if (this.allowBackdropClose) {
        this.$emit('close')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/base/breakpoint.scss";

$bg-color: #282828;

.popup-container {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1072;
  background-color: $bg-color;
  width: 90vw;
  height: 470px;

  @include breakpoint("small") {
    width: 450px;
  }

  .close-btn {
    background-color: $bg-color;
    width: 20px;
    height: 20px;
    right: 10px;
    top: 10px;
  }
}

.modal-backdrop {
  z-index: 1071;
}
</style>



// WEBPACK FOOTER //
// src/components/popup-container.vue